<template>
  <div >
    <iframe :src="src" class="iframe" >
      <p>Your browser does not support iframes.</p>
    </iframe>
  </div>
</template>

<script>

export default {
  data() {
    return {
      src: 'https://fruitsoss.yunyihudong.com/shortPlay/common/v200/kuaiShortPlay/index_dafeng.html?coinName=云币&appName=快看剧&company=厦门云剧互动科技有限公司',
      isHide: false,
      pageOpacity: 0
    }
  },
  computed: {
  },

  created(options) {
  }
}
</script>
<style lang="less">
.iframe {

position: absolute;
border:none;

left: 0;

right: 0;

top: 0;

bottom: 0;

width: 100%;

height: 100%;

background: #fff;

overflow-y: hidden;

}</style>
